import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import api from '../../../../common/api/api';

const currentEnv = process.env.NEXT_PUBLIC_NODE_ENV || 'dev';
const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

export const handleLogin = createAsyncThunk(
  'auth/handleLogin',
  async (email: string, { rejectWithValue }) => {
    const requestData: { email: string; env: string } = {
      email,
      env: currentEnv ?? 'prod',
    };

    try {
      const { t } = useTranslation();
      const response = await api.post(`${BASE_URL}/email_link`, requestData);
      toast.success(t('check_email_toast'));
      localStorage.setItem('emailForSignIn', email);
      return response.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue((error as any).response.data);
    }
  },
);

const AuthSlice = createSlice({
  name: 'auth',
  initialState: {
    loading: false,
    error: null as string | null,
    user: null,
  },
  reducers: {
    setUser: (state, action) => {
      const user = action.payload;
      state.user = user;
    },
  },
});

export const { setUser } = AuthSlice.actions;

export default AuthSlice.reducer;
